/*
 * iframe
 */
import React, { useContext, useEffect } from 'react';
import Empty from './Empty';
import { useMethods } from '@lhb/hook';
import { MainAppContext } from '@/index';

const IMIframe: React.FC<any> = ({ src, id = 'iframe' }) => {
  const { container } = useContext(MainAppContext);

  const methods = useMethods({
    // 向子页面传值
    postMessageToSon({ type, data }) {
      const iframe = ((container || document).getElementById('iframeRef') as any)?.contentWindow;
      iframe?.postMessage({ type: type, data: data }, '*');
    },
    // 接收子页面传递参数
    receiveImMessageHandler({ data: { type, data } }) {
      if (type === 'spotDetail' && data) {
        window.open(`/lhb-micro-pms/pointMng/detail?tenantSpotId=${data}`);
      }
    }
  });
  useEffect(() => {
    window.addEventListener('message', methods.receiveImMessageHandler, false);
  }, []);
  useEffect(() => {
    methods.postMessageToSon({ type: 'reload' });
  }, [src]);
  return (
    <>
      {src ? <iframe id={id} key={src} src={src} allow='clipboard-write' style={{ border: 0, width: '100%', height: 640 }}></iframe> : <Empty />}
    </>
  );
};

export default IMIframe;
